// Dependencies
import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import axios from 'axios';
import qs from 'qs';
import SweetAlert from 'react-bootstrap-sweetalert';

function onlyLettersSpaces(text) {
    if (!text.match(/^[ a-zA-Zá-źÁ-Ź]+$/)) {
        return 'Nombre inválido';
    }

    return false;
}

function onlyNumbers(text) {
    if (!text.match(/^\+{0,1}[1-9]{1}[0-9]{5,10}$/)) {
        return 'Número inválido';
    }

    return false;
}

class FormularioContactoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nombre: '',
            email: '',
            telefono: '',
            empresa: '',
            mensaje: '',
            gRecaptchaResponse: '',
            msgErrorNombre: '',
            msgErrorEmail: '',
            msgErrorTelefono: '',
            msgErrorEmpresa: '',
            msgErrorMensaje: '',
            msgErrorGRecaptchaResponse: '',
            showSuccessSweetAlert: false,
            showErrorSweetAlert: false,
            isLoading: false,
            titleSweetAlert: '',
            captchaValid: false,
            descriptionSweetAlert: '',
            buttonSend: 'disabled',
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.callback = this.callback.bind(this);

        this.handleFieldNameBlur = this.handleFieldNameBlur.bind(this);
        this.handleFieldEmailBlur = this.handleFieldEmailBlur.bind(this);
        this.handleFieldTelefonoBlur = this.handleFieldTelefonoBlur.bind(this);
        this.handleFieldMessageBlur = this.handleFieldMessageBlur.bind(this);
    }

    callback() {
        this.setState({
            captchaValid: false
        });
    }

    expiredCallback() {
        this.setState({
            captchaValid: false
        });
    }

    verifyCallback(response) {
        this.setState({
            msgErrorGRecaptchaResponse: '',
            gRecaptchaResponse: response,
            captchaValid: true
        });
        this.verifyFormComplete();
    }

    resetRecaptcha() {
        this.setState({
            captchaValid: false
        });
        this.recaptcha.reset();
    }

    handleFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    clearForm() {
        this.setState({ nombre: '', email: '', telefono: '', empresa: '', mensaje: '' });
    }

    verifyFormComplete() {
        const fieldsRequired = ['nombre', 'email', 'telefono', 'mensaje'];
        let cont = 0;

        fieldsRequired.map((value, key) => {
            if (this.state[value] !== '') cont = cont + 1;

            return cont;
        });

        if (
            cont === 4 &&
            this.state.msgErrorNombre === '' &&
            this.state.msgErrorEmail === '' &&
            this.state.msgErrorTelefono === '' &&
            this.state.msgErrorEmpresa === '' &&
            this.state.msgErrorMensaje === '' &&
            this.state.msgErrorGRecaptchaResponse === ''
        )
            this.setState({ buttonSend: '' });
        else this.setState({ buttonSend: 'disabled' });
    }

    handleFieldNameBlur(event) {
        const value = event.target.value;

        if (!value) this.setState({ msgErrorNombre: 'Debe ingresar un nombre' });
        else if (onlyLettersSpaces(value)) this.setState({ msgErrorNombre: onlyLettersSpaces(value) });
        else if (value.length < 6) this.setState({ msgErrorNombre: 'Debe ingresar un mínimo de 6 caracteres' });
        else if (value.length > 100)
            this.setState({ msgErrorNombre: 'El mensaje no puede ser superior a los 100 caracteres' });
        else this.setState({ msgErrorNombre: '' });

        this.verifyFormComplete();
    }

    handleFieldEmailBlur(event) {
        const value = event.target.value;
        const contAt = this.state.email.split('@').length - 1;
        const lastAtPos = this.state.email.lastIndexOf('@');
        const lastDotPos = this.state.email.lastIndexOf('.');

        if (!value) this.setState({ msgErrorEmail: 'Debe ingresar un email' });
        else if (
            !(
                contAt === 1 &&
                lastAtPos < lastDotPos &&
                lastAtPos > 0 &&
                lastDotPos > 2 &&
                value.length - lastDotPos > 2
            )
        )
            this.setState({ msgErrorEmail: 'El email es inválido' });
        else this.setState({ msgErrorEmail: '' });

        this.verifyFormComplete();
    }

    handleFieldTelefonoBlur(event) {
        const value = event.target.value;

        if (!value) this.setState({ msgErrorTelefono: 'Debe ingresar un teléfono' });
        else if (onlyNumbers(value)) this.setState({ msgErrorTelefono: onlyNumbers(value) });
        else this.setState({ msgErrorTelefono: '' });

        this.verifyFormComplete();
    }

    handleFieldMessageBlur(event) {
        const value = event.target.value;

        if (!value) this.setState({ msgErrorMensaje: 'Debe ingresar un mensaje' });
        else if (value.length > 200)
            this.setState({ msgErrorMensaje: 'El mensaje no puede ser superior a los 200 caracteres' });
        else this.setState({ msgErrorMensaje: '' });

        this.verifyFormComplete();
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (!this.state.gRecaptchaResponse)
            this.setState({ msgErrorGRecaptchaResponse: 'Por favor haga click en el cuadro de reCAPTCHA' });
        else {
            const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
            this.setState({
                isLoading: true
            })
            axios
                .post(
                    'https://insacom.cl/back/email.php',
                    qs.stringify({
                        nombre: this.state.nombre,
                        asunto: this.props.asunto || 'Sin Asunto',
                        correo: this.state.email,
                        empresa: this.state.empresa,
                        fono: this.state.telefono,
                        mensaje: this.state.mensaje,
                        gRecaptchaResponse: this.state.gRecaptchaResponse,
                    }),
                    config
                )
                .then((response) => {
                    this.setState({
                        isLoading: false
                    });
                    if (!response.data.success) {
                        this.setState({ showErrorSweetAlert: true });
                        this.setState({ titleSweetAlert: 'Error' });
                        this.setState({ descriptionSweetAlert: response.data.msg });
                    } else {
                        this.setState({ showSuccessSweetAlert: true });
                        this.setState({ titleSweetAlert: 'Éxito' });
                        this.setState({ descriptionSweetAlert: 'Mensaje Enviado' });
                        this.clearForm();
                        this.resetRecaptcha();
                        this.setState({ gRecaptchaResponse: '' });
                    }
                })
                .catch(function (error) {
                    this.setState({
                        isLoading: false
                    });
                    this.setState({ showErrorSweetAlert: true });
                    this.setState({ titleSweetAlert: 'Error' });
                    this.setState({ descriptionSweetAlert: 'Ha ocurrido un error' });
                });
        }
    }

    hiddenSweetAlert = () => {
        this.setState({ showSuccessSweetAlert: false });
        this.setState({ showErrorSweetAlert: false });
    };

    render() {
        const sitekey = '6Lck5-cUAAAAAB-otI7k-rOu3eXx-1XryC-SGnlh';
        const {
            nombre,
            email,
            telefono,
            empresa,
            mensaje,
            msgErrorNombre,
            msgErrorEmail,
            msgErrorTelefono,
            msgErrorEmpresa,
            msgErrorMensaje,
            msgErrorGRecaptchaResponse,
            titleSweetAlert,
            descriptionSweetAlert,
            showSuccessSweetAlert,
            showErrorSweetAlert,
            buttonSend,
            isLoading,
            captchaValid
        } = this.state;
        return (
            <div className="row justify-content-between">
                <div className="col-md-12">
                    <form id="form-contacto" onSubmit={this.handleFormSubmit}>
                        <div className="g-mb-10">
                            <label for="nombre" className="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                                Nombre: <span className="g-color-red">*</span>
                            </label>
                            <input
                                id="nombre"
                                name="nombre"
                                value={nombre}
                                onChange={this.handleFieldChange}
                                onBlur={this.handleFieldNameBlur}
                                className="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-primary--focus rounded-3 g-py-10 g-px-15"
                                type="text"
                            />
                            <span className="g-color-red g-font-size-12">{msgErrorNombre}</span>
                        </div>
                        <div className="g-mb-10">
                            <label for="email" className="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                                Email: <span className="g-color-red">*</span>
                            </label>
                            <input
                                id="email"
                                name="email"
                                autoComplete='off'
                                value={email}
                                onChange={this.handleFieldChange}
                                onBlur={this.handleFieldEmailBlur}
                                className="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-primary--focus rounded-3 g-py-10 g-px-15"
                                type="text"
                            />
                            <span className="g-color-red g-font-size-12">{msgErrorEmail}</span>
                        </div>
                        <div className="g-mb-10">
                            <label for="telefono" className="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                                Teléfono: <span className="g-color-red">*</span>
                            </label>
                            <input
                                id="telefono"
                                name="telefono"
                                value={telefono}
                                onChange={this.handleFieldChange}
                                onBlur={this.handleFieldTelefonoBlur}
                                className="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-primary--focus rounded-3 g-py-10 g-px-15"
                                type="text"
                            />
                            <span className="g-color-red g-font-size-12">{msgErrorTelefono}</span>
                        </div>
                        <div className="g-mb-10">
                            <label for="empresa" className="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">Empresa:</label>
                            <input
                                id="empresa"
                                name="empresa"
                                value={empresa}
                                onChange={this.handleFieldChange}
                                className="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-primary--focus rounded-3 g-py-10 g-px-15"
                                type="text"
                            />
                            <span className="g-color-red g-font-size-12">{msgErrorEmpresa}</span>
                        </div>
                        <div className="g-mb-20">
                            <label for="mensaje" className="g-color-gray-dark-v2 g-font-weight-600 g-font-size-13">
                                Mensaje: <span className="g-color-red">*</span>
                            </label>
                            <textarea
                                id="mensaje"
                                name="mensaje"
                                value={mensaje}
                                onChange={this.handleFieldChange}
                                onBlur={this.handleFieldMessageBlur}
                                className="form-control g-color-gray-dark-v5 g-bg-white g-bg-white--focus g-brd-primary--focus g-resize-none rounded-3 g-py-10 g-px-15"
                                rows="7"
                            ></textarea>
                            {/* <EmptyField value={mensaje} name="mensaje" /> */}
                            <span className="g-color-red g-font-size-12">{msgErrorMensaje}</span>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <Recaptcha
                                    ref={(e) => (this.recaptcha = e)}
                                    sitekey={sitekey}
                                    render="explicit"
                                    hl="es"
                                    verifyCallback={this.verifyCallback}
                                    onloadCallback={this.callback}
                                    expiredCallback={this.expiredCallback}
                                />
                                <span className="g-color-red g-font-size-12">{msgErrorGRecaptchaResponse}</span>
                            </div>
                            <div className="col-lg-6 g-mb-20">
                                <button
                                    disabled={buttonSend || isLoading || !captchaValid}
                                    id="enviar-form"
                                    name="enviar-form"
                                    className="btn btn-lg u-btn-primary pull-right g-mt-15 g-font-weight-600 g-font-size-default rounded-3 text-uppercase g-py-15 g-px-30"
                                    type="submit"
                                >
                                    {isLoading ? <i className="fa g-mr-10 fa-circle-o-notch fa-spin"></i> : null}
                                    Enviar
                                </button>
                                <SweetAlert
                                    danger
                                    show={showErrorSweetAlert}
                                    title={titleSweetAlert}
                                    onConfirm={this.hiddenSweetAlert}
                                >
                                    {descriptionSweetAlert}
                                </SweetAlert>
                                <SweetAlert
                                    success
                                    show={showSuccessSweetAlert}
                                    title={titleSweetAlert}
                                    onConfirm={this.hiddenSweetAlert}
                                >
                                    {descriptionSweetAlert}
                                </SweetAlert>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default FormularioContactoForm;



// WEBPACK FOOTER //
// ./src/subcomponents/FormularioContactoForm.js